$(document).ready(function(){

    $('.bxslider').bxSlider({
        mode: 'fade',
        auto:true,
        captions:true
    });

    $('.emailMobileInput').focus(function(){
       $('.emailMobLabel').addClass('emailMobLabelMove');
    });

    $('.emailMobileInput').blur(function(){
        var splVal = $(this).val();
        if(splVal.length >= 1){
        } else {
            $('.emailMobLabel').removeClass('emailMobLabelMove');
        }
    });

    $('.passwordInput').focus(function(){
        $('.passwLabel').addClass('emailMobLabelMove');
    });

    $('.passwordInput').blur(function(){
        var splVal = $(this).val();
        if(splVal.length >= 1){
        } else {
            $('.passwLabel').removeClass('emailMobLabelMove');
        }
    });

    $(window).on("load resize", function(){
            function fun() {
                var longHgt = new Array();
                $('.featuredBox').each(function(){
                    longHgt.push($(this).outerHeight());
                });
                var max = Math.max.apply(Math, longHgt);
                $('.featuredBox').css({'min-height': max});
            }
        fun()
    });

/*

        var totalWidth = $(window).width();
            if(totalWidth < 430) {
                minSliderSpl = 1;
            } else if(totalWidth < 600) {
                minSliderSpl = 4;
            } else {
                minSliderSpl = 6;
            }

        var obxSettings = {
            auto:false,
            minSlides: minSliderSpl,
            maxSlides: 6,
            shrinkItems:true,
            pager:false,
            slideMargin:5,
            slideWidth: 960
        };

    var ink = $('.recentViewSlider').bxSlider(obxSettings);
    */

    $(window).on("load resize", function(){
        var totalWidth = $(window).width();
        var minSliderSpl;
        if(totalWidth < 430) {
            minSliderSpl = 1;
        } else if(totalWidth < 600) {
            minSliderSpl = 4;
        } else {
            minSliderSpl = 6;
        }

        var obxSettings = {
            auto:false,
            minSlides: minSliderSpl,
            maxSlides: minSliderSpl + 2,
            shrinkItems:true,
            pager:false,
            slideMargin:5,
            slideWidth: 960
        };

        $('.recentViewSlider').bxSlider(obxSettings);

    });



/*
    $(window).resize(function(){
        var totalWidth = $(window).width();
        if(totalWidth < 430) {
            $('.recentViewSlider').bxSlider(ink.minSlides:1);
        } else if(totalWidth < 600) {
            maxSlides = 4;
        } else {
            maxSlides = 6;
        }
    });
*/


});
